import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {useSyncExternalStore} from 'react'

import {getSelectedFullDiffHash, parseDiffHash} from '../helpers/document-hash-helpers'

function subscribe(callback: () => void) {
  window.addEventListener('hashchange', callback)
  return () => window.removeEventListener('hashchange', callback)
}

function getPathDigestSnapshot(): string {
  const windowHash = parseDiffHash(ssrSafeLocation.hash ?? '') ?? ''
  return windowHash.replace('diff-', '')
}

function getServerSnapshot(): string {
  return ''
}

export function useSelectedDiffHash(): string {
  return useSyncExternalStore(subscribe, getPathDigestSnapshot, getServerSnapshot)
}

export function useSelectedFullDiffHash(): string {
  return useSyncExternalStore(subscribe, getSelectedFullDiffHash, getServerSnapshot)
}
